import React, { useState } from 'react';
import { Button } from '@mui/material';
import SelectMonthDialog from '../Dialogs/SelectMonthDialog';
import DropzoneDialog from '../Dropzone/DropzoneDialog';

interface UploadXlsxFileButtonProps {
    buttonName: React.ReactNode;
    uploadFiles: (files: File[], closeHandler: () => void) => void;
    dialogTitle: string;
    style?: React.CSSProperties;
    monthForUploading?: string;
    variant?: 'contained' | 'outlined' | 'text';
    onChangeMonthForUploading?: (month: string) => void;
    loading?: boolean;
}

const UploadXlsxFileButton: React.FC<UploadXlsxFileButtonProps> = ({
    buttonName,
    monthForUploading,
    onChangeMonthForUploading,
    uploadFiles,
    dialogTitle,
    style,
    variant = 'contained',
    loading,
}) => {
    const [openDropzoneDialog, setOpenDropzoneDialog] = useState(false);

    const [openSelectMonthDialog, setOpenSelectMonthDialog] = useState(false);
    const [uploadedExcelFiles, setUploadedExcelFiles] = useState<File[]>([]);

    const handleDropzoneDialogOpen = () => {
        setOpenDropzoneDialog(true);
    };

    const handleDropzoneDialogClose = () => {
        setUploadedExcelFiles([]);
        setOpenDropzoneDialog(false);
    };

    const handleDropzoneDialogSave = (files: File[]) => {
        if (files.length > 0) {
            if (monthForUploading) {
                setOpenSelectMonthDialog(true);
                setUploadedExcelFiles(files);
            } else {
                uploadFiles(files, handleDropzoneDialogClose);
            }
        }
    };

    const handleSelectMonthDialogClose = () => {
        setOpenSelectMonthDialog(false);
    };

    const handleSelectMonthDialogSave = () => {
        setOpenSelectMonthDialog(false);
        if (monthForUploading) {
            uploadFiles(uploadedExcelFiles, handleDropzoneDialogClose);
        }
    };

    const handleSelectMonthDialogChange = (month: string) => {
        if (onChangeMonthForUploading) onChangeMonthForUploading(month);
    };

    return (
        <>
            <Button onClick={handleDropzoneDialogOpen} variant={variant} style={style} disabled={loading}>
                {buttonName}
            </Button>
            <DropzoneDialog
                open={openDropzoneDialog}
                onClose={handleDropzoneDialogClose}
                onUpload={handleDropzoneDialogSave}
                dialogTitle={dialogTitle}
                multiple={false}
                accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                uploadedFiles={uploadedExcelFiles}
                onUploadedFilesChange={setUploadedExcelFiles}
                loading={loading}
            ></DropzoneDialog>
            {monthForUploading && (
                <SelectMonthDialog
                    open={openSelectMonthDialog}
                    onSave={handleSelectMonthDialogSave}
                    onClose={handleSelectMonthDialogClose}
                    onChange={handleSelectMonthDialogChange}
                    selectedValue={monthForUploading}
                ></SelectMonthDialog>
            )}
        </>
    );
};

export default UploadXlsxFileButton;
